import { FollowUpSurveyInstance } from '@nkr/enums/follow-up-survey-instance';

export interface IFollowUpSurvey {
    id: number,
    centerId: number,
    centerName: string,
    centerAlias: string,
    dashDomain: string,
    editKey: string,

    followUpDonorId: number,

    surveyInstanceId: number,
    surveyInstance: string,

    statusId: number,
    status: string,

    isReviewed: boolean,
    reviewedByUserId: number,
    reviewedByUserName: string,
    reviewedByContactName: string,
    reviewedDateTime: string,

    areLabResultsGood: boolean,
    labResultsReviewedByUserId: number,
    labResultsReviewedByUsername: string,
    labResultsReviewedByContactId: number,
    labResultsReviewedByContactName: string,
    labResultsReviewedDateTime: string,
    isNotifiedOfLabResults: boolean,

    reminderStatusId: number,
    reminderStatus: string,

    labOrdersUploadFile: string,
    labsCompletedWhen: string,
    labsCompletedWhere: string,

    surveyInitiatedDateTime: string,
    surveySubmittedDateTime: string,
    labChoiceDateTime: string,
    labOrdersUploadedDateTime: string,
    followUpCompletedDateTime: string,
    complianceDueDate: string,

    email: string,
    phone: string,
    fullName: string,
    firstName: string,
    lastName: string,
    countryId: number,
    country: string,
    addressLine1: string,
    city: string,
    state: string,
    nonUsStateProvince: string,
    postalCode: string,

    birthDate: string,
    donationDate: string,

    heightInches: number,
    weightLbs: number,
    bmi: number,

    bpDiastolic: number,
    bpSystolic: number,
    lastSeenByPhysician: string,
    hasHighBp: boolean,
    hasDiabetes: boolean,
    diabeticUsesInsulin: boolean,
    diabeticUsesOralMeds: boolean,
    diabeticUsesDiet: boolean,
    hadOtherComplications: boolean,
    otherComplicationDescription: string,
    hadUrgentCare: boolean,
    urgentCareDescription: string,

    physicalCapacityId: number,
    physicalCapacity: string,

    percentFunctional: number,

    hasRegrets: boolean,
    regretsDescription: string,

    workStatusId: number,
    workStatus: string,
    outOfWorkReason: string,

    hasLostInsurance: boolean,
    lostInsuranceDescription: string,

    hasStartedDialysis: boolean,
    startedDialysisDescription: string,

    additionalInformation: string,

    coordinatorContactId: number,
    coordinatorContactEmail: string,

    isLate: boolean,
    isAlmostLate: boolean,
    isSurveyLate: boolean,
    areLabsLate: boolean,

    previousSurvey: FollowUpSurveyInstance
}